import AuthenticationService from "service/auth/AuthenticationService";
import EnvironmentService from "service/environment/EnvironmentService";
import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import ApiService from "../../../../../service/network/APIService";

let environmentService = new EnvironmentService();
let serviceAPI = environmentService.getServiceAPI();
let header = {
  Authorization: "api-labtest-request-service",
  client: "service",
};
class NavigoAPIServices {
  constructor() {
    this.authenticationService = new AuthenticationService();
    this.environmentService = new EnvironmentService();
    this.apiService = new APIService();
  }
  getChallengeDetails(id, onResponse, onError) {
    let url = APIConfig.disqualificationUser.challengeDetails.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  reactivePid(payload, onResponse, onError) {
    let url = APIConfig.disqualificationUser.reactivePid;
    return this.apiService.put(url, payload, onResponse, onError);
  }
  getDisqualifiedData(payload, onResponse, onError) {
    let url = APIConfig.disqualificationUser.getDisqualifiedData;
    return this.apiService.post(url, payload, onResponse, onError);
  }
  disqualifyUser(payload, onResponse, onError) {
    let url = APIConfig.disqualificationUser.disqualifyUser;
    return this.apiService.post(url, payload, onResponse, onError);
  }
}

export default NavigoAPIServices;
